import axios from "axios";
import baseURL from "./base_url";

const campaignApi = axios.create({
  baseURL,
});

export const getCampaigns = () => {
  return campaignApi
    .get(`/campaign/all`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const createCampaigns = (identificador, template, data) => {
  return campaignApi
    .post(`/campaign/create/${identificador}/${template}`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      responseType: "blob",
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const createTemplateCollection = (data) => {
  return campaignApi
    .post(`/templateCollection/create`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};
export const updateCampaigns = (data) => {
  return campaignApi
    .put(`/campaign`, data)
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const deleteCampaign = ({ _id }) => {
  return campaignApi
    .delete(`/campaign/delete/${_id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const launchCampaign = ({ _id }) => {
  return campaignApi
    .post(
      `/campaign/launchCampaigns/${_id}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const sendCsv = (id, data) => {
  return campaignApi
    .post(`/campaign/insertLeads-xls/${id}`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const downloadCampaign = ({ _id }) => {
  return campaignApi
    .get(`/campaign/extractCampaignReport/${_id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      responseType: "blob",
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const getCampaign = (id) => {
  return campaignApi
    .get(`/campaign/findById/${id}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};
